// extracted by mini-css-extract-plugin
export default {"submitSaveAndSend":"_1oWh4qTlLuS1Aim1raHEXv button success","submitSaveAndSendIcon":"_34FMjks0OKSpCLuR7Zr3Rw"};